<template>
  <div class="order-card">
    <div class="px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4">
      <span v-if="isMobile" class="inline-block cursor-pointer" @click="expand()">
        <Chevron direction="down" />
      </span>
      <div class="flex items-center gap-6" v-if="!isMobile">
        <img :src="data.delivery_service.delivery_service_logo" class="max-h-14" v-if="data.delivery_service.delivery_service_logo" />
        <LogisticPlaceholder :logisticName="data.delivery_service.delivery_service_name" v-else />
        <span class="text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md text-center" v-if="data.delivery_service.delivery_service_name"
          >{{ data.delivery_service.delivery_service_name }} ({{ data.delivery_service.delivery_service_package_name }})</span
        >
      </div>
      <div class="flex gap-4">
        <Button :buttonText="$t('order.uploadOrderCard.editButton')" :type="'secondary'" :size="isMobile ? 'full' : 'regular'" @action="editOnClick" />
        <Button :buttonText="$t('order.uploadOrderCard.deleteButton')" :type="'delete'" :size="isMobile ? 'full' : 'regular'" @action="handleDeleteTempOrder(data.id)" />
      </div>
    </div>

    <div class="flex justify-between items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none" :class="{ hidden: !visibleContent && isMobile }">
      <div class="w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b">
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.senderName') }}</p>
            <p class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden" :title="data.sender.sender_name">{{ data.sender.sender_name }}</p>
            <p class="text-neutral-400 text-sm">{{ data.sender.sender_phone }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.senderAddress') }}</p>
            <p class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto">{{ data.sender.sender_address }}</p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
          <p>{{ data.pickup_detail || '-' }}</p>
        </div>
      </div>
      <div class="w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap">{{ $t('order.orderCard.receiverName') }}</p>
            <p class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden" :title="data.receiver.receiver_name">{{ data.receiver.receiver_name }}</p>
            <p class="text-neutral-400 text-sm">{{ data.receiver.receiver_phone }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.receiverAddress') }}</p>
            <p class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto">{{ data.receiver.receiver_address }}</p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.detailShipping') }}</p>
          <p>{{ data.destination_detail || '-' }}</p>
          <p class="text-xs italic text-red-500">{{ data.errors.destination }}</p>
        </div>
      </div>
      <div class="w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="mb-3">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.weight') }}</p>
          <p>{{ data.goods.goods_weight }} kg</p>
        </div>
        <div class="mb-3">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.goodsCategory') }}</p>
          <p>{{ data.goods.goods_category }}</p>
        </div>
        <div class="">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.price') }}</p>
          <p>{{ formatCurrency(data.price) }}</p>
          <p class="text-xs italic text-red-500">{{ data.errors.serviceCost }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Chevron: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Chevron'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    LogisticPlaceholder: () => import(/* webpackChunkName: "LogisticPlaceholder" */ '@/components/Icons/LogisticPlaceholder')
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visibleContent: false,
      status: {
        PYMWAI: 'text-neutral-500 bg-neutral-300',
        PYMCNF: 'text-white bg-system-warning',
        DLVD: 'text-white bg-system-success',
        CNC: 'text-white bg-system-error',
        HUBPRCD: 'text-white bg-system-warning',
        HUBRJCT: 'text-white bg-system-error',
        OCNCL: 'text-white bg-red-500'
      }
    }
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('order', ['deleteTempOrder']),
    async handleDeleteTempOrder(tempOrderId) {
      this.showLoading()
      try {
        await this.deleteTempOrder({ tempOrderId })
      } catch (error) {
        console.error(error)
      } finally {
        this.hideLoading()
        this.$router.push({ path: '/order/step/upload' })
      }
    },
    formatCurrency(value) {
      if (!value) return 'Rp 0'
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
      }).format(value)
    },
    goToDetail(id) {
      this.$router.push(`/order/detail/${id}`)
    },
    expand() {
      this.visibleContent = !this.visibleContent
    },
    editOnClick() {
      this.$router.push(`/order/step/upload/${this.data.id}/edit`)
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    statusClass() {
      return this.status[this.data.status]
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 60px;
  word-break: break-all;
}
</style>
